<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="user-role"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :disable-create="true"
          :action-width="180"
        >
          <template
            v-if="canEdit && !loading && data.length == 0"
            v-slot:action
          >
            <v-col md="3">
              <v-btn
                depressed
                class="ma-1"
                color="primary"
                small
                @click="onClickCreate()"
              >
                <v-icon small left>mdi-plus</v-icon>
                Tambah Role
              </v-btn>
            </v-col>
          </template>
          <template v-slot:item.roles="{ item }">
            {{ item.roles_name.join(", ") }}
          </template>
        </datatable>
      </div>
    </div>
    <form-user-role ref="formRole" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="user-role"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormUserRole from "./FormUserRole";

export default {
  data() {
    return {
      title: "User",
      url: "user-role/data?id=" + this.id,
      columns: [
        {
          value: "id"
        },
        // {
        //   text: "Wilayah",
        //   value: "zone_name",
        //   sortable: true,
        //   searchable: true,
        // },
        {
          text: "Role",
          value: "roles",
          sortable: false,
          searchable: true
        }
      ],
      data: [],
      loading: true
    };
  },
  props: {
    id: String,
    canEdit: Boolean
  },
  methods: {
    onClickCreate() {
      this.$refs.formRole.getListZone();
      this.$refs.formRole.open(this.id);
    },
    onClickUpdate(item) {
      this.$refs.formRole.open(this.id, item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs.datatable.items;
      },
      val => {
        this.data = val;
        this.loading = false;
      }
    );
  },
  components: {
    Datatable,
    DeleteDialog,
    FormUserRole
  }
};
</script>
